import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AnimalType } from "../components/3d/Animal3DModel";

export type HeadwearType = "none" | "straw_hat" | "top_hat" | "beret" | "crown" | "flower";
export type OutfitType = "default" | "tie" | "apron" | "cape" | "bandana" | "bowtie";
export type AccessoryType = "none" | "glasses" | "sunglasses" | "backpack" | "camera";
export type ColorTintType = "default" | "sakura" | "latte" | "mint" | "snow";

export interface DressupState {
  animalType: AnimalType;
  headwear: HeadwearType;
  outfit: OutfitType;
  accessory: AccessoryType;
  colorTint: ColorTintType;

  setAnimalType: (type: AnimalType) => void;
  setHeadwear: (item: HeadwearType) => void;
  setOutfit: (item: OutfitType) => void;
  setAccessory: (item: AccessoryType) => void;
  setColorTint: (item: ColorTintType) => void;
  resetToDefault: () => void;
}

export const useDressupStore = create<DressupState>()(
  persist(
    (set) => ({
      animalType: "bunny",
      headwear: "none",
      outfit: "default",
      accessory: "none",
      colorTint: "default",

      setAnimalType: (animalType) => set({ animalType }),
      setHeadwear: (headwear) => set({ headwear }),
      setOutfit: (outfit) => set({ outfit }),
      setAccessory: (accessory) => set({ accessory }),
      setColorTint: (colorTint) => set({ colorTint }),
      resetToDefault: () =>
        set({
          headwear: "none",
          outfit: "default",
          accessory: "none",
          colorTint: "default",
        }),
    }),
    {
      name: "nihongo-animal-dressup",
    },
  ),
);
